import { version } from '../package.json'

import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/plugins'
import '@/styles/main.scss'
import 'element-ui/lib/theme-chalk/index.css'

import './permission.js'
import { bootstrap } from './bootstrap'
// import VSelect from '@alfsnd/vue-bootstrap-select'

import './socket.io'

import '@/panels'

Vue.config.productionTip = false

async function main() {
  await bootstrap(router, store)
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#HawaApp')

  // eslint-disable-next-line
  console.log(
    `%c Hawa application %c v${version} %c`,
    'background:#ff0000 ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff; border: 1px solid #ff0000;',
    'background:#ffffff ; padding: 1px; border-radius: 0 3px 3px 0;  color: #f00; border: 1px solid #ff0000;',
    'background:transparent'
  )
}

main()
